<template>
  <window-container class="reserved-window">
    <div style="background-color:#b0c8f5;font-weight:bold;padding:4px;">Reserviation</div>
    <table>
      <tr>
        <td>Description</td>
        <td>{{ product.description }}</td>
      </tr>
      <tr>
        <td>Part no.</td>
        <td>{{ product.part_no }}</td>
      </tr>
      <tr>
        <td>Brand</td>
        <td>{{ product.brand }}</td>
      </tr>
      <tr>
        <td>Qty</td>
        <td>
          <el-input v-model.number="form.qty" style="width:200px;"></el-input>
        </td>
      </tr>
      <tr>
        <td>Company</td>
        <td>
          <company-select v-model="form.company_id" style="width:200px;"></company-select>
        </td>
      </tr>
      <tr>
        <td>For</td>
        <td>
          <sales-select v-model="form.sales_id" style="width:200px;"></sales-select>
        </td>
      </tr>
      <tr>
        <td>Remarks</td>
        <td>
          <el-input v-model="form.remark" style="width:300px;"></el-input>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <el-button @click="save">Hold</el-button>
          <el-button @click="reset">Reset</el-button>
          <el-button @click="close">Close</el-button>
        </td>
      </tr>
    </table>
    <div style="background-color:#b0c8f5;font-weight:bold;padding:4px;margin-top:10px;">Queue</div>
    <table>
      <tr>
        <th>Date</th>
        <th>Qty</th>
        <th>Company</th>
        <th>Sales</th>
        <th>Remarks</th>
        <th>Cancel</th>
      </tr>
      <tr v-for="item in historyList" :key="item.id">
        <td>{{ item.oper_time | shortDateTime }}</td>
        <td>{{ item.qty }}</td>
        <td>{{ item.company_name }}</td>
        <td>{{ item.sales_name }}</td>
        <td>{{ item.remark }}</td>
        <td>
          <el-button @click="del(item)">Cancel</el-button>
        </td>
      </tr>
    </table>
    <div style="text-align:center;padding:30px 0;" v-if="historyList.length === 0">No Data</div>
  </window-container>
</template>

<script>
import CompanySelect from '@/components/CompanySelect'
import SalesSelect from '@/components/SalesSelect'
export default {
  components: {
    CompanySelect,
    SalesSelect
  },
  data () {
    return {
      product: {},
      form: {
        product_id: 0,
        qty: 0,
        company_id: null,
        sales_id: null,
        remark: ''
      },
      historyList: []
    }
  },
  mounted () {
    this.fetchProduct()
    this.fetchHistory()
  },
  methods: {
    fetchProduct () {
      this.$http.get('/dbapi/product_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.product = data.list[0]
          this.form.product_id = this.product.id
        }
      })
    },
    fetchHistory () {
      this.$http.get('/dbapi/reserved_list?product_id=' + this.$route.params.id).then(data => {
        this.historyList = data.list
      })
    },
    save () {
      if (!this.form.company_id) {
        this.$message({
          type: 'error',
          message: 'Please select a company'
        })
        return
      }
      if (!this.form.sales_id) {
        this.$message({
          type: 'error',
          message: 'Please select a sales'
        })
        return
      }
      this.$http.post('/dbapi/reserved_insert', this.form).then(data => {
        this.fetchHistory()
      })
    },
    del (row) {
      this.$confirm('Are you sure you want to cancel?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/reserved_del', {
          id: row.id,
          qty: row.qty
        }).then(data => {
          this.fetchHistory()
        })
      })
    },
    reset () {
      this.form.qty = 0
      this.form.company_id = null
      this.form.sales_id = null
      this.form.remark = null
    },
    close () {
      this.$close()
    }
  }
}
</script>

<style>
.reserved-window table {
  width: 100%;
  border-spacing: 0;
  border-left: 1px solid #999;
  border-top: 1px solid #999;
}
.reserved-window table th,.reserved-window table td {
  padding: 2px;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
}
</style>

